import React, { useRef } from "react";
import DrivingSteeringWhite from "@images/game-pass/drivingSteeringWhite.svg";
import ImageSlider from './ImageSlider';
import FirstImageSlider from './FirstImageSlider';
import { BuyLifePointDataItem, bottomcontainerGamepassStyle, topContainerGamepassStyle, LifePointPassUseDetails } from '@util/config';
import Link from "next/link";

const GamePass = ({ buyNft }) => {
  const scrollRef = useRef(null);

  const handleClick = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  return (
    <>
      <div className="relative h-screen w-screen overflow-auto bg-[#FAFAFA]">
        <Link
          href='/dashboard'
          className='absolute right-[16px] top-[12px]'
        >
          <p className='text-[#FAFAFA] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Close </p>
        </Link>
        <div style={topContainerGamepassStyle} className="w-auto md:h-[330px] lg:h-[480px] xl:h-[680px] sm:h-[240px]">
          <div className="sm:w-[60%] absolute xl:top-[20%] lg:top-[16%] sm:top-[8%] left-[50%] -translate-x-1/2 -translate-y-1/2 xl:gap-[18px] lg:gap-[16px] sm:gap-[6px] flex flex-col justify-center items-center text-center">
            <p className="text-[#FAFAFA] text-center xl:text-[54px] lg:text-[42px] sm:text-[24px] not-italic font-semibold xl:leading-[64px] lg:leading-[32px] sm:leading-[28px] sm:tracking-[-0.84px] tracking-[-3.84px]">
              Experience the Open World
            </p>
            <p className="text-[#FAFAFA] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
              Your ticket to a new digital world can start at $39.99.
            </p>
            {/* <button className="flex sm:w-[150px] lg:w-[300px] sm:h-[38px] lg:h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] border-[1px] border-solid border-[#737373] bg-[#25BD66]" onClick={handleClick}>
              <img src={DrivingSteeringWhite} className='w-[20px] h-[20px]' alt="DrivingSteeringWhite" />
              <p className="text-[#FAFAFA] sm:text-[16px] lg:text-[20px] not-italic font-bold leading-[25px] tracking-[-0.8px]">Buy now!</p>
            </button> */}
          </div>
        </div>
        <div className="max-w-[910px] flex flex-col items-center gap-[16px] mx-auto xl:mt-[22px] xl:mb-[50px] lg:mt-[18px] lg:mb-[30px] md:-mt[7px] md:mb-[28px] sm:-mt-[18px] sm:mb-[10px]">
          <p className="w-[605px] text-[#000] text-center lg:text-[42px] sm:text-[32px] not-italic font-semibold leading-[44px] tracking-[-0.6px]">
            Buy or refill LPs (Life Points)
          </p>
          <div className="flex flex-col gap-[6px]">
            <p className="w-[686px] text-[#737373] text-center text-[18px] not-italic font-medium leading-[22px] tracking-[-0.72px]">
              Every failed mission completion will cost you 1 LP.
            </p>
            <p className="w-[686px] text-[#737373] text-center text-[18px] not-italic font-medium leading-[22px] tracking-[-0.72px]">
              Each game pass includes complementary TCs (Time Credits; 1 TC = 1 USD).
            </p>
          </div>
        </div>
        <div ref={scrollRef} className="w-full flex flex-col justify-center items-center gap-[32px]">
          <div className="xl:w-[44%] lg:w-[62%] md:w-[80%] sm:w-[88%] mx-auto flex lg:p-[24px] sm:p-[12px] justify-center items-center lg:gap-[24px] sm:gap-[12px] rounded-[32px] bg-[#EFEFEF] [box-shadow:0px_8px_16px_0px_rgba(0,_0,_0,_0.10)]">
            {BuyLifePointDataItem.map((item, index) => (
              <div
                className="w-full flex p-[24px] flex-col items-center gap-[24px] rounded-[24px] bg-[#FAFAFA] hover:shadow-[0px_4px_24px_0px_#65FFA7] cursor-pointer border-solid transition duration-300 hover:scale-105 hover:border-[#65FFA7]"
                key={index}
              >
                <div className="w-auto h-[315px]">
                  <img
                    src={item.lifeimg}
                    alt="img-fluid"
                    className="w-[100%] h-[100%]"
                  />
                </div>
                <div className="flex w-full h-[300px] flex-col justify-between items-start">
                  <div className="flex flex-col items-start gap-[16px]">
                    <div className="flex flex-col items-start gap-[4px]">
                      <p className="text-[#737373] lg:text-[18px] sm:text-[14px] not-italic font-medium leading-[22px] tracking-[-0.72px]">{item.timecradit}</p>
                      <div className="flex items-center gap-[8px]">
                        <p className="text-[#000] lg:text-[32px] sm:text-[22px] not-italic font-semibold leading-[32px] tracking-[-1.92px]">{item.usd}</p>
                        {item.lp && (
                          <span className="text-[#25BD66] text-[18px] not-italic font-semibold leading-[28px] tracking-[-0.72px]">
                            {item.lp}
                          </span>
                        )}
                      </div>
                    </div>
                    <p className="text-[#737373] lg:text-[18px] sm:text-[14px] not-italic font-medium leading-[22px] tracking-[-0.72px]">
                      {item.pragraph}
                    </p>
                  </div>
                  <div className="w-full flex flex-col items-center gap-[4px]">
                    {item.text &&
                      <div className='flex flex-row items-center gap-[4px]'>
                        <p className="text-[#FF6610] lg:text-[20px] sm:text-[14px] not-italic font-semibold leading-[24px] tracking-[-1.2px]">
                          {item.text}
                        </p>
                        <img
                          src={item.icon}
                          alt="img-fluid"
                          className="w-[24px] h-[24px]"
                        />
                      </div>
                    }
                    {/* <button className="w-full flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] border-[1px] border-solid border-[rgba(255,255,255,0.10)] bg-[#000]" onClick={() => buyNft(item.amount)}>
                      <img src={DrivingSteeringWhite} className='w-[20px] h-[20px]' alt="DrivingSteeringWhite" />
                      <p className="text-[#FAFAFA] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.8px]">Buy now!</p>
                    </button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="xl:w-[60%] lg:w-[85%] md:w-[93%] sm:w-[95%] mt-[30px] bg-[#EFEFEF] mx-auto p-[24px] rounded-[32px]">
          <p className="text-[#000] text-center text-[36px] not-italic font-semibold leading-[32px] tracking-[-2.16px]">
            How to use a Life Points Pass
          </p>
          <div className="md:mt-[28px] mt-[15px]">
            <div className=" items-center gap-[24px] grid grid-cols-3">
              {LifePointPassUseDetails.map((item, index) => (
                <div
                  className="flex p-[24px] flex-col items-center gap-[24px] rounded-[24px] bg-[#FAFAFA] h-full"
                  key={index}
                >
                  <div className="flex w-[32px] h-[32px] justify-center items-center gap-[10px] rounded-[200px] bg-[#000]">
                    <p className="text-[#FAFAFA] text-[22.423px] not-italic font-bold leading-[16.194px] tracking-[-1.345px]">
                      {index + 1}
                    </p>
                  </div>
                  <div className="flex flex-col items-start gap-[8px]">
                    <p className="text-[#000] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]">{item.title}</p>
                    <div className="flex flex-col gap-[10px]">
                      <p className="text-[#737373] text-[18px] not-italic font-medium leading-[22px] tracking-[-0.72px]">
                        {item.pragraph}
                      </p>
                      <p className="text-[#737373] text-[18px] not-italic font-medium leading-[22px] tracking-[-0.72px]">
                        {item.detalis}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-[31px] my-[36px]">
          <p className="lg:w-[44%] sm:w-[60%] text-[#000] text-center lg:text-[38px] sm:text-[28px] not-italic font-bold lg:leading-[40px] sm:leading-[32px] tracking-[-2.56px]">
            The most sprawling, realistic, high-stakes open-world game in the
            world.
          </p>
          <p className="text-[#737373] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
            Interact, enjoy, and travel across the world from the comfort of
            your home screen.
          </p>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex flex-col xl:gap-[20px] gap-[6px]">
            <FirstImageSlider />
            <ImageSlider />
          </div>
          <div style={bottomcontainerGamepassStyle}>
            <div className="flex flex-col justify-center items-center 2xl:gap-[16px] gap-[24px] pt-[130px]">
              <p className="xl:w-[100%] w-[482px] text-[#FAFAFA] text-center text-[48px] not-italic font-semibold leading-[52px] tracking-[-2.88px]">
                A new global adventure awaits you.
              </p>
              <div className="flex flex-col justify-center items-center gap-[34px]">
                <p className="text-[#FAFAFA] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
                  Your ticket to a new digital world starts at $39.99.
                </p>
                {/* <button className="flex w-[300px] h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] border-[1px] border-solid border-[#737373] bg-[#25BD66]" onClick={handleClick}>
                  <img src={DrivingSteeringWhite} className='w-[20px] h-[20px]' alt="DrivingSteeringWhite" />
                  <p className="text-[#FAFAFA] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.8px]">Buy now!</p>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GamePass;